import axios from "axios"

const storeApi = {
    getStoreList: (params) => {
        const url = '/store'
        return axios.get(url, params)
    },
    addStore: (params) => {
        const url = '/store'
        return axios.post(url, params)
    },
    getStoreInfo: (storeId) => {
        const url = `/store/${storeId}`
        return axios.get(url)
    },
    patchStore: (storeId, params) => {
        const url = `/store/${storeId}`
        return axios.patch(url, params)
    },
    updateVersion: (params) => {
        const url = `/store/version`
        return axios.patch(url, params)
    },
    deleteStore: (storeId) => {
        const url = `/store/${storeId}`
        return axios.delete(url)
    }

}

export default {
    install(app) {
        app.config.globalProperties.storeApi = storeApi
    }
}
